<template>
  <div class="notice">
    <Header @search="onSearch" />
    <Tab />
    <div class="notice_coniner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">{{
          $t('首页')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }">{{
          $t('新闻中心')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('服贸故事') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="N_bar">
        <p>{{ $t('服贸故事') }}</p>
      </div>
      <ul class="noticeList" v-if="noticeList != ''">
        <li
          v-for="(item, index) in noticeList"
          :key="index"
          @click="detailBtn(item)"
          :clstag="`newscenter|keycount|stories-pc|click-${item.title}`"
        >
          <span>{{ index + 1 + (current - 1) * pageSize }}</span>
          <span :class="{ actives: item.isMark == 1 }">
            <p class="text-oneline width900" style="display: inline">
              {{ item.title }}
            </p>
            <i v-if="item.pubTime >= todyTimer">
              <img src="@/assets/img/new.png" alt="" />
            </i>
          </span>
          <span>{{ item.pubTime || item.createTime | dataFilter(true) }}</span>
        </li>
      </ul>
      <ul v-else class="no_make">
        {{
          $t('暂无数据')
        }}
      </ul>
      <div class="page">
        <p @click="subCurrent">&lt;&lt;</p>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :current-page="current"
          :page-size="pageSize"
          :total="total"
          :clstag="`newscenter|keycount|stories-pc|click-handleCurrentChange`"
        >
        </el-pagination>
        <p @click="addCurrent">&gt;&gt;</p>
        <span
          >{{ $t('共') }} {{ total }} {{ $t('条结果') }} / {{ current }}
          {{ $t('页') }}</span
        >
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import '@/assets/css/notice.css'
import { getNoticeList } from '@/api/news'
import Header from './components/headerBanner'
import Tab from './components/headerTab'
import Footer from './components/footer'
export default {
  components: {
    Header,
    Tab,
    Footer
  },
  data() {
    return {
      noticeList: [],
      current: 1,
      pageSize: 10,
      total: 0,
      todyTimer: ''
    }
  },
  created() {
    this.code = this.$route.query.code
    this.fetchList()
    window.scroll(0, 0)
  },
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    handleCurrentChange(current) {
      this.current = current
      this.fetchList()
    },
    detailBtn(item) {
      if (item.contentType == 1 && item.url) {
        window.open(item.url, '_blank')
      } else {
        this.$router.push({
          path: '/consult',
          query: {
            id: item.contentId,
            type: 9
          }
        })
      }
    },
    fetchList() {
      getNoticeList({
        cls: this.code,
        pageSize: this.pageSize,
        pageNum: this.current
      }).then(res => {
        this.noticeList = res.result && res.result.infos
        this.total = res.result.total
      })
    },
    subCurrent() {
      this.current = 1
      this.fetchList()
    },
    addCurrent() {
      this.current = Math.ceil(this.total / this.pageSize)
      this.fetchList()
    }
  },
  beforeMount() {
    this.todyTimer = new Date().setHours(0, 0, 0, 0)
  }
}
</script>
